// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer_footerWrapper__3Adfw","person":"footer_person__3U8fz","hrLine":"footer_hrLine__wwV_i"};